import PropTypes from 'prop-types';
import { FunctionField, SelectField, TextField, usePermissions, useRecordContext, useTranslate } from 'react-admin';
import { DetailsShow } from '@/components/global/drawers/DetailsShow.jsx';
import { DetailsActionsPopover } from '@/components/global/buttons/DetailsActionsPopover.jsx';
import CustomEditModalButton from '@/components/global/buttons/CustomEditModalButton.jsx';
import CustomDeleteButton from '@/components/global/buttons/CustomDeleteButton.jsx';
import { DrawerLink } from '@/components/global/drawers/DrawerLink.jsx';
import { useDrawer } from '@/composables/useDrawer.js';
import { canViewDetails } from '@/helpers/permissions/canViewDetails.js';
import { softwareTypeChoices } from '@/components/global/options/selectOptions.jsx';

const SoftwareAliasDetailsActions = ({ handleClose }) => {
    const record = useRecordContext();
    const translate = useTranslate();
    const { permissions } = usePermissions();
    const { openDrawer } = useDrawer();

    if (!permissions?.isAdmin || !record?.id) {
        return null;
    }

    return (
        <DetailsActionsPopover>
            <CustomEditModalButton label={translate('resources.softwareAlias.labels.edit')} onOpen={() => openDrawer(record.id, 'software-alias-edit')} />
            <CustomDeleteButton
                resource='software-alias'
                id={String(record.id)}
                label={translate('resources.softwareAlias.labels.delete')}
                disabled={record?.isLinked}
                onSuccess={handleClose}
            />
        </DetailsActionsPopover>
    );
};

SoftwareAliasDetailsActions.propTypes = {
    handleClose: PropTypes.func,
};

export const SoftwareAliasShow = ({ handleClose, elementId }) => {
    const translate = useTranslate();

    return (
        <DetailsShow
            handleClose={handleClose}
            elementId={elementId}
            resource='software-alias'
            canView={permissions => canViewDetails('software-alias', permissions)}
            actions={<SoftwareAliasDetailsActions handleClose={handleClose} />}
            showChangeHistory
            historyFieldsSource='resources.softwareAlias.fields'
        >
            <TextField source='name' label={translate('resources.softwareAlias.fields.name')} />
            <SelectField source='software.type' choices={softwareTypeChoices} label={translate('resources.softwareAlias.fields.type')} />
            <FunctionField
                label={translate('resources.softwareAlias.fields.software')}
                render={record =>
                    record?.softwareId ? (
                        <DrawerLink resource='software' action='show' source={record.softwareId} label={record.software?.version} relative />
                    ) : null
                }
            />
        </DetailsShow>
    );
};

SoftwareAliasShow.propTypes = {
    handleClose: PropTypes.func.isRequired,
    elementId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
